




import { Component, Prop, Vue } from "vue-property-decorator";

import { AutomaticReportJobCompetitor } from "@/models";
import { AutomaticReportJobCompetitorSnapshot } from "@/models/AutomaticReports/AutomaticReportJob";
import DetailsTable from "@/components/Agencies/ReportBuilder/DetailsTable.vue";
import {
  DetailRow,
  DetailSection,
  EMPTY,
  buildCompetitorDetailRows,
  formatBackendDate,
  profileLabel,
  timeSlotsValue,
  userLabel,
} from "@/components/Agencies/ReportBuilder/competitorDetailRows";
import {
  AUTOMATIC_REPORT_JOB_STATUS_LABELS,
  describeGranularity,
} from "@/components/Agencies/ReportBuilder/automaticReport";
import { formatApiDate } from "@/services/ApiDateHelper";

@Component({ components: { DetailsTable } })
export default class AutomaticReportJobDetailsTable extends Vue {
  @Prop({ required: true })
  readonly automaticReportJob!: AutomaticReportJobCompetitor;

  get snapshot(): AutomaticReportJobCompetitorSnapshot {
    return this.automaticReportJob.data || {};
  }

  get statusLabel(): string {
    return (
      AUTOMATIC_REPORT_JOB_STATUS_LABELS[this.automaticReportJob.status] ||
      this.automaticReportJob.status
    );
  }

  formatTimestamp(value?: string): string {
    return formatApiDate(value, "DD/MM/YYYY HH:mm") || EMPTY;
  }

  get generalRows(): DetailRow[] {
    const automaticReportJob = this.automaticReportJob;
    const automaticReportSnapshot = this.snapshot.automaticReport;

    const rows: DetailRow[] = [
      {
        label: "Nome report",
        value: automaticReportSnapshot?.name || `Job #${automaticReportJob.id}`,
      },
      { label: "Stato", value: this.statusLabel },
      {
        label: "Periodo di estrazione",
        value: `${formatBackendDate(
          this.snapshot.startsAt
        )} → ${formatBackendDate(this.snapshot.endsAt)}`,
      },
      { label: "Messaggio", value: automaticReportJob.message || EMPTY },
      {
        label: "Data creazione",
        value: this.formatTimestamp(automaticReportJob.createdAt),
      },
      {
        label: "Ultima modifica",
        value: this.formatTimestamp(automaticReportJob.updatedAt),
      },
    ];

    if (automaticReportJob.profile) {
      rows.push({
        label: "Profilo",
        value: profileLabel(automaticReportJob.profile),
      });
    }
    if (automaticReportJob.user) {
      rows.push({
        label: "Utente",
        value: userLabel(automaticReportJob.user),
      });
    }

    return rows;
  }

  get recurrenceRows(): DetailRow[] {
    const automaticReportSnapshot = this.snapshot.automaticReport;
    if (!automaticReportSnapshot) return [];

    const rows: DetailRow[] = [
      {
        label: "Dimensione estrazione",
        value: describeGranularity(automaticReportSnapshot),
      },
    ];

    const competitor = automaticReportSnapshot.competitorAttributes;
    if (competitor) {
      rows.push({
        label: "Confronto",
        value: competitor.compare ? "sì" : "no",
      });
      if (competitor.compare) {
        rows.push({
          label: "Periodo di confronto",
          value: `${formatBackendDate(
            competitor.comparisonStartsAt
          )} → ${formatBackendDate(competitor.comparisonEndsAt)}`,
        });
      }
      rows.push({
        label: "Fasce orarie",
        value: timeSlotsValue(competitor.timeSlotsFilter),
      });
    }

    return rows;
  }

  get sections(): DetailSection[] {
    const sections: DetailSection[] = [
      { title: "Informazioni job", rows: this.generalRows },
    ];

    const recurrenceRows = this.recurrenceRows;
    if (recurrenceRows.length) {
      sections.push({ title: "Ricorrenza", rows: recurrenceRows });
    }

    const templateCompetitor =
      this.snapshot.reportTemplate?.competitorAttributes;
    if (templateCompetitor) {
      const rows = buildCompetitorDetailRows(templateCompetitor);
      if (rows.length) {
        sections.push({ title: "Configurazione", rows });
      }
    }

    return sections;
  }
}
